import { render, staticRenderFns } from "./orderListGoods.vue?vue&type=template&id=360f3726&"
import script from "./orderListGoods.vue?vue&type=script&lang=js&"
export * from "./orderListGoods.vue?vue&type=script&lang=js&"
import style0 from "./orderListGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports